import { Spinner } from 'components/design';
import OWContainer from 'styles/styled-components/ow-container';
import { ProductForm } from '../components/product-form';
import SelectNestedProductDialog from '../components/select-nested-products-dialog';
import useController from '../controllers/edit-product-controller';

export const EditProductRoute = () => {
    const {
        formData,
        onChange,
        onSubmit,
        onCancel,
        places,
        productCategories,
        dataChanged,
        isLoading,
        isEditProductLoading,
        errors,
        placeConfigData,
        isAdmin,
        isEdit,
        updateAll,
        setUpdateAll,
        onConfigPriceChange,
        placeId,
        nestedCategoriesWithNestedProducts,
        isSelectedNestedProductsDialogOpen,
        toggleSelectedNestedProductsDialog,
        onSelectNestedProductComplete,
        selectedNestedProducts,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <ProductForm
                    formData={formData}
                    places={places}
                    productCategories={productCategories}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditProductLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                    isEdit={isEdit}
                    placeConfigData={placeConfigData}
                    updateAll={updateAll}
                    setUpdateAll={setUpdateAll}
                    onConfigPriceChange={onConfigPriceChange}
                    placeId={placeId}
                    toggleSelectNestedProductDialog={toggleSelectedNestedProductsDialog}
                    selectedNestedProducts={selectedNestedProducts}
                />
            )}
            {isSelectedNestedProductsDialogOpen && (
                <SelectNestedProductDialog
                    isOpen={isSelectedNestedProductsDialogOpen}
                    toggleDialog={toggleSelectedNestedProductsDialog}
                    nestedProductCategoriesWithProducts={nestedCategoriesWithNestedProducts}
                    onSelectNestedProductComplete={onSelectNestedProductComplete}
                    initalSelectedNestedProducts={selectedNestedProducts}
                />
            )}
        </OWContainer>
    );
};
